module.exports = __webpack_public_path__ + "static/img/pingworthLogo.0a374ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pingworthLogo.png
// module id = h/CN
// module chunks = 2